import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Icon from 'react-fa';
import { Link } from 'react-router';
import { t } from '../helpers/translate';
import { request } from '../helpers/request';
import ModalComponent from './common/ModalComponent';
import LoadingComponent from './common/LoadingComponent';
import icons from '../Logos/AgentDashboard/Icons';
let config = require('config');

class AgentDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activePromoIndex: 0,
      dashboardData: {
        promos: [],
        bannerImageUrl: null,
        statements: [],
        documents: [],
        leaderboard: []
      },
      loading: false,
      error: null
    };

    this.promoInterval = null;
  }

  componentDidMount() {
    this.fetchDashboardSummary();
  }

  componentWillUnmount() {
    if (this.promoInterval) {
      clearInterval(this.promoInterval);
    }
  }

  startPromoCarousel = () => {
    if (this.promoInterval) clearInterval(this.promoInterval);

    this.promoInterval = setInterval(() => {
      const { dashboardData, activePromoIndex } = this.state;
      const promos = dashboardData.promos || [];

      if (promos.length > 1) {
        const nextIndex = (activePromoIndex + 1) % promos.length;
        this.setState({ activePromoIndex: nextIndex });
      }
    }, 10000);
  };

  handlePromoClick = (index) => {
    this.setState({ activePromoIndex: index });
    this.startPromoCarousel();
  };

  openPromotion = (promo) => {
    if (!promo || !promo.id) return;

    request(`${config.default.api}/downloadResource/${promo.id}`, 'GET', null, (responseData, status) => {
      const response = responseData || {};
      const signedUrl = response.signed_url || response.signedUrl;

      if (status === 200 && signedUrl) window.open(signedUrl, '_blank');
    });
  };

  promoBody(tileName, tileData) {
    const items = tileData.items || [];

    if (items.length === 0) {
      return <div className='mt-8 text-center'>{t('No promotions available at this time.')}</div>;
    }

    const activeIndex = this.state.activePromoIndex;
    const activePromo = items[activeIndex];

    return (
      <div>
        <div className='promo-body'>
          <img
            src={activePromo.image_url}
            alt={activePromo.name}
            className='promo-img'
          />
          <div className='promo-text font-family-SemiBold'>
            <h4 className='font-family-SemiBold' style={{ WebkitBoxOrient: 'vertical' }}>{activePromo.name}</h4>
            <p className='font-family-Regular' style={{ WebkitBoxOrient: 'vertical' }}>{activePromo.description}</p>
            <button className='btn-purple-solid promo-button' onClick={() => this.openPromotion(activePromo)}>
              {t('See Promotion')}
            </button>
          </div>
        </div>

        {items.length > 1 && (
          <div className='carousel-dots text-center'>
            {items.map((_, i) => (
              <span
                key={i}
                className={`dot ${i === activeIndex ? 'active' : ''}`}
                onClick={() => this.handlePromoClick(i)}
                style={{ cursor: 'pointer' }}
              ></span>
            ))}
          </div>
        )}
      </div>
    );
  }

  handleDownload = (e, item) => {
  e.preventDefault();
  if (!item.url) return;

  fetch(item.url)
    .then((res) => {
      if (!res.ok) alert(t('Error downloading file'));
      return res.blob();
    })
    .then((blob) => {
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = item.document_name || item.url.split('/').pop().split('?')[0];
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch(() => window.open(item.url, '_blank'));
};

  renderattchements(item, i, tileData) {
    return (
      <div className='list-item' key={i}>
        <div className='item-left'>
          <img src={tileData.icon} width='20px' height='20px' className='mr-2' /> <span>{item.name}</span>
        </div>
        <div className='item-right'>
          <a href={item.url || '#'} target='_blank' rel='noopener noreferrer' className='preview-icon mr-1'
          />
          <a href={item.url || '#'} onClick={(e) => this.handleDownload(e, item)} className='download-icon'
          />
        </div>
      </div>
    )
  }

  renderLeaderboardItem(item, i, tileData) {
    const Rank = {
      '1': icons.Rank1,
      '2': icons.Rank2,
      '3': icons.Rank3
    }
    return (
      <div className={`leaderboard-card ${item.isYou ? 'bg-light-purple' : ''}`} key={i}>
        <div className='rank-left font-family-SemiBold'>
          <img src={Rank[`${item.rank}`]} /> <span>{t(item.name)}</span>
        </div>
        <span className='score'>{item.score} {t('pts')}</span>
      </div>
    )
  }

  reusableListTiles(tileName, tileData) {
    return (
      <Col xs={12} md={6} lg={4} className='d-flex mb-8'>
        <div className='dash-card flex-fill'>
          <div className='card-header-custom'>
            <span className='text-purple font-family-SemiBold'> <img src={tileData.img} /> {t(tileData.label)}</span>
            {tileName === 'promos' && <Link to={{ pathname: tileData.link, state: { display: tileData.display } }}>{t('View all')}</Link>}
          </div>
          {tileName === 'promos' ? this.promoBody(tileName, tileData) : (
            <div className='card-body'>
              <div className='list-body'>
                {tileData.items.length > 0 ? tileData.items.map((item, i) => (
                  tileName === 'leaderboard' ? this.renderLeaderboardItem(item, i, tileData) : this.renderattchements(item, i, tileData)
                )) :
                  <div className='mt-8 mb-4 text-center'>{`No ${tileName} available at this time.`}</div>
                }
              </div>
              <div className='card-footer-link'>
                <Link to={{ pathname: tileData.link, state: { display: tileData.display } }}>{t(tileData.footerLabel)} <Icon name='angle-right' /></Link>
              </div>
            </div>
          )}
        </div>
      </Col>
    );
  }

  fetchDashboardSummary = () => {
    this.setState({ loading: true, loadingText: t('Loading') });

    request(`${config.default.api}/agentDashboard`, 'GET', null, (responseData, status) => {
      if (status === 200) {
        const dashboardData = responseData[0];
        const promos = dashboardData.promos || [];
        const statements = dashboardData.statements || [];
        const documents = dashboardData.documents || [];
        const leaderboard = dashboardData.leaderboard || [];
        const bannerImageUrl = dashboardData.banner_image_url || null;

        this.setState({
          loading: false,
          dashboardData: {
            promos,
            bannerImageUrl,
            statements,
            documents,
            leaderboard
          }
        }, () => {
        if (this.state.dashboardData.promos.length > 1) {
            this.startPromoCarousel();
        }
        });
      } else {
        this.setState({ loading: false });
        this.showModal(t('Error'), responseData.messages.map((m, i) => <p key={i}>{m}</p>));
      }
    });
  };

  render() {
    const { userName, allowedTiles } = this.props;
    const { dashboardData, loading, error } = this.state;
    const tiles = config.default.landing.tiles;
    const iconMap = {
      'Quotes': icons.Quotes,
      'Statements': icons.Statements,
      'SellNow': icons.SellNow,
      'MSHAcademy': icons.MSHAcademy,
    };

    return (
      <div className='agent-dashboard-wrapper'>
        <section className='agent-hero-section'>
          <div className='hero-background'>
            <div className='container hero-content'>
              <h5 className='greeting-text mb-2'>{t('Hello')} {userName},</h5>
              <h2 className='main-heading mb-4'>{t('Welcome to your')}<br />{t('MSH Agent Dashboard')}</h2>
              <h5 className='sub-heading'>{t('Everything you need to sell travel insurance')}<br />{t('and grow your business.')}</h5>
            </div>
            <div className='container quick-tiles-container'>
              <Row>
                {allowedTiles.map((tile, idx) => (
                  <Col md={3} sm={6} key={idx} className='mb-3'>
                    <Link className='quick-tile-link' to={tiles[tile].link}>
                      <div className={`quick-tile shadow-sm`}>
                        {/* <div className='icon-wrap'><Icon name={tiles[tile].icon} /></div> */}
                        <div className='icon-wrap'><img src={iconMap[tiles[tile].img]} /></div>
                        <div className='text-wrap'>
                          <h4 className='font-weight-bold'>{t(tiles[tile].label)}</h4>
                          <p>{t(tiles[tile].sub)}</p>
                        </div>
                      </div>
                    </Link>
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        </section>

        <div className='container'>
          <section className='dashboard-body'>
            <Row className='dashboard-row'>
              {this.reusableListTiles('promos', { icon: 'star-o', link: '/resource_centre', label: 'Incentive Programs', items: dashboardData.promos, img: icons.Incentives, display: 'promos' })}

              {this.reusableListTiles('statements', { icon: icons.StatementFile, link: '/commissions', label: 'Your Agent Statements', items: dashboardData.statements.length ? dashboardData.statements : [], footerLabel: 'See all Statements', img: icons.Statements })}

              {this.reusableListTiles('forms', { icon: icons.DocumentFile, link: '/documents', label: 'Forms & Documents', items: dashboardData.documents.length ? dashboardData.documents : [], footerLabel: 'See all Documents', img: icons.Forms })}

              {/* Tile 4: Leaderboard */}
              {this.reusableListTiles('leaderboard', { icon: '', link: '/resource_centre', label: 'Sales Leaderboard', items: dashboardData.leaderboard ? dashboardData.leaderboard : [], footerLabel: 'View full leaderboard', display: 'leaderboard', img: icons.Leaderboard })}

              <Col xs={12} md={12} lg={8} className='d-flex mb-8'>
                <div className='dash-card flex-fill'>
                  <div className='card-header-custom'>
                    <span className='text-purple font-family-SemiBold'><img src={icons.MSHAcademy} /> {t('MSH Academy')}</span>
                  </div>
                  <div className='academy-grid'>
                    <Row>
                      {[
                        { title: 'Training Hub', desc: 'Access learning and onboarding resources', icon: icons.TrainingHub, link: 'training' },
                        { title: 'Travel Advisories', desc: 'View destination alerts and updates', icon: icons.TravelAdvisories, link: 'government' },
                        { title: 'Currency Exchange', desc: 'Check exchange rates and currency tools', icon: icons.CurrencyExchange, extLink: 'https://www.bankofcanada.ca/rates/exchange/?page_moved=1' },
                      ].map((card, i) => (
                        <Col xs={12} md={4} key={i}>
                          <div className='academy-card'>
                            <div className='acad-icon bg-light-purple text-purple'>
                              <img src={card.icon}/>
                            </div>
                            <div className='acad-text'>
                              <span className='font-family-SemiBold'>{t(card.title)}</span>
                              <p className='font-family-Regular' style={{ WebkitBoxOrient: 'vertical' }}>{t(card.desc)}</p>
                            </div>
                            <Link
                              className='acad-arrow'
                              {...(card.extLink ? { href: card.extLink, target: '_blank' } : { to: { pathname: '/resource_centre', state: { display: card.link } } })}
                            />
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </div>
                  <div className='card-footer-link justify-content-center pt-3 border-top-0 mt-auto font-family-SemiBold'>
                    <Link
                      to={{ pathname: '/resource_centre', state: { display: 'resource' } }}
                    >{t('Browse all Resources')} <Icon name='angle-right' /></Link>
                  </div>
                </div>
              </Col>
            </Row>
          </section>

          {dashboardData.bannerImageUrl && (
            <section className='footer-section mb-5'>
              <img className='footer-image-banner shadow' src={dashboardData.bannerImageUrl} alt={t('Dashboard banner')} />
            </section>
          )}
        </div>
        <LoadingComponent show={this.state.loading} text={this.state.loadingText} />

        <ModalComponent
          title={this.state.modalTitle}
          body={this.state.modalBody}
          onClose={this.handleModalClose}
          show={this.state.showModal}
          onSubmit={this.state.modalAction}
          resetDataOnClose={this.state.resetDataOnClose}
          buttonName={this.state.modalOptionalButton}
        />
      </div>
    )
  }
}

export default AgentDashboard;



// WEBPACK FOOTER //
// ./src/components/AgentDashboard.js